/**
 * ViaCEP integration — free, no key, no rate limit for reasonable use.
 * Given a Brazilian CEP (with or without dash), returns the address fields
 * or null on error. Silently swallows network/parse issues so the caller
 * can just do `if (out) { ... }`.
 */
export async function lookupCep(cep) {
  if (!cep) return null;
  const digits = String(cep).replace(/\D/g, "");
  if (digits.length !== 8) return null;
  try {
    const r = await fetch(`https://viacep.com.br/ws/${digits}/json/`);
    if (!r.ok) return null;
    const d = await r.json();
    if (d.erro) return null;
    return {
      cep: d.cep || digits,
      street: d.logradouro || "",
      neighborhood: d.bairro || "",
      city: d.localidade || "",
      state: d.uf || "",
    };
  } catch { return null; }
}

/** Concatenate a ViaCEP payload + optional number/complement into a single
 *  address line ready for `client_address`. */
export function formatAddress(viacep, number, complement) {
  if (!viacep) return "";
  const line1 = [viacep.street, number].filter(Boolean).join(", ");
  const line2 = [viacep.neighborhood, viacep.city && `${viacep.city} - ${viacep.state}`, viacep.cep].filter(Boolean).join(", ");
  return [line1, complement, line2].filter(Boolean).join(", ");
}

export function maskCep(v) {
  const d = String(v || "").replace(/\D/g, "").slice(0, 8);
  return d.length > 5 ? `${d.slice(0, 5)}-${d.slice(5)}` : d;
}
